export default __webpack_public_path__ + "static/media/Kanika.1a9c12fa.jpg";